import React from 'react'
import TopFiveSectionTemplate_Kratos from './TopFiveSectionTemplate_Kratos';
import { useSelector } from 'react-redux';
import { selectLoggedInUser } from "../../../redux/userSlice"

export default function TopFiveSection_Kratos(props) {
  let { gloablfilter } = props;
  const singleVinSelected = (vin) => {
    props.singleVinSelected(vin);
  }
  const loggedInUser = useSelector(selectLoggedInUser);
  return (

    <div className="accordion accordionSec" id="accordionExample">
      {
        loggedInUser.flagForHideShow === "ERC" &&
        // (loggedInUser.flagForHideShow === "ERC" || loggedInUser.flagForHideShow === "FLEETEV") &&
        <TopFiveSectionTemplate_Kratos gloablfilter={gloablfilter} singleVinSelected={singleVinSelected} IND="RANGE" title=" 5 Range VINs" template_id="collapseOne" show={true} soarting={true}>
        </TopFiveSectionTemplate_Kratos>
      }
      {
        loggedInUser.flagForHideShow === "ERC" &&
        // (loggedInUser.flagForHideShow === "ERC" || loggedInUser.flagForHideShow === "FLEETEV") &&
        <TopFiveSectionTemplate_Kratos gloablfilter={gloablfilter} singleVinSelected={singleVinSelected} IND="WHR" title=" 5 kWh VINs " template_id="collapseTwo" show={false} soarting={true}>
        </TopFiveSectionTemplate_Kratos>
      }
      {
        loggedInUser.flagForHideShow === "ERC" ?
          <TopFiveSectionTemplate_Kratos gloablfilter={gloablfilter} singleVinSelected={singleVinSelected} IND="DISTANCE " title="Top 5 Distance VINs " template_id="collapseThree" show={false} soarting={false}>
          </TopFiveSectionTemplate_Kratos>
          : <TopFiveSectionTemplate_Kratos gloablfilter={gloablfilter} singleVinSelected={singleVinSelected} IND="DISTANCE " title="Top 5 Distance VINs " template_id="collapseThree" show={true} soarting={false}>
          </TopFiveSectionTemplate_Kratos>
      }
    </div>
  )
}
